// Protected app layout templates for header, footer, and the authenticated shell.
interface ProtectedLayoutTemplateInput {
	contentHtml: string
	footerHtml: string
	headerHtml: string
	navHtml: string
	previewPlayerHtml: string
}

/** Renders the small brand header used inside the authenticated layout. */
export function headerTemplate(): string {
	return `
        <header class="login-header">
            <img class="login-logo" src="/assets/svg/claim.svg" alt="Tunetoss" />
        </header>
  `
}

/** Renders the Discogs attribution footer. */
export function footerTemplate({
	currentYear = new Date().getFullYear(),
	secondaryHtml = '',
}: {
	currentYear?: number
	secondaryHtml?: string
} = {}): string {
	return `
      <footer>
          <p class="f secondary">
            © ${currentYear} Tunetoss. Data provided by
            <a href="https://www.discogs.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Discogs.
            </a>
          </p>
          ${secondaryHtml}
      </footer>
  `
}

/** Renders the authenticated app shell around navigation and page content. */
export function protectedLayoutTemplate({
	contentHtml,
	footerHtml,
	headerHtml,
	navHtml,
	previewPlayerHtml,
}: ProtectedLayoutTemplateInput): string {
	return `
		${previewPlayerHtml}
		${navHtml}
		<main id="content">
			${headerHtml}
			${contentHtml}
			${footerHtml}
		</main>
		<div id="overlay-root" hidden>
			<div id="overlay-content" role="dialog"></div>
		</div>
	`
}
